/**
 * Base origin for backend API calls.
 *
 * Cloud builds (staging/prod) bake VITE_API_URL="" so every request resolves
 * same-origin (`/api/v1/...`); the Load Balancer routes `/api/*` to the backend
 * Cloud Run service while everything else hits the frontend service. That keeps
 * a single frontend image valid for every environment (build-once /
 * promote-by-digest, exactly like the backend container).
 *
 * `??` — not `||` — so an explicit empty string is honored as "same-origin"
 * instead of falling through to the local-dev default. When VITE_API_URL is
 * left unset (local docker-compose), it falls back to the compose backend.
 */
export const API_URL: string =
  import.meta.env.VITE_API_URL ?? 'http://localhost:8000';
